import { MFinanzaEdoCtaMovimientoDetalle } from "../../../../data/model/FinanzaEstadoCuenta/MFinanzaEdoCtaMovimientoDetalle";
import { _SvFinanzasObtenerCargoAplicadoPorID } from "../../../../data/modulo/FinanzasAsignaciones";
import _L, { TLabelTag } from "../../../../util/Labels";
import { _ModalSimple } from "../../../controlD3/ModalThings/ModalSimple";
import { NotificacionV2 } from "../../../controlD3/NotificacionV2";
import { UIUtilFormat } from "../../../util/Format";
import { UIUtilTime } from "../../../util/Time";
import { UIUtilViewData } from "../../../util/ViewData";
import { UIUtilViewFinanzaCargo } from "../../FinanzasIngresos/FinanzaCargo";


export function AlumnoEdoCtaMovDetalleGeneralModal<TMode extends ("descuento" | "morosidad")>(mode: TMode, dato: MFinanzaEdoCtaMovimientoDetalle) {
    _ModalSimple({
        Title: _L("panelfinanzasedocuenta.tag_details"),
        Width: 350,
        DrawContent: async (content, modalThings) => {
            const infoNoFoundTag = _L("general.notif_infonodisponible");
            const fnBuildInfoTags = (tagsArray: [TLabelTag, string][]) => {
                // >> Draw
                let html = "";
                tagsArray
                    .forEach((tags) => {
                        html += `<label><b>${_L(tags[0])}</b>: ${tags[1] || infoNoFoundTag}</label>`;
                    });

                content
                    .classed("body_informacion", true)
                    .html(html);
            }

            switch (mode) {
                case "descuento":
                    const descuentoData = (dato as MFinanzaEdoCtaMovimientoDetalle);
                    fnBuildInfoTags([
                        ["panelfinanzasedocuenta.tag_descript", descuentoData.Cargo],
                        ["panelfinanzasedocuenta.tag_val", UIUtilFormat._CurrencyFmt(descuentoData.Valor)], // NOTE Falta el valor de tipo Porcentaje
                        ["panelfinanzasedocuenta.tag_tipo", UIUtilViewData._GetStr_TipoValor(descuentoData.TipoValor)]
                    ])
                    break;
                case "morosidad":
                    modalThings.Progress.attr("oculto", false);
                    let tagRecargos = _L("panelfinanzasedocuenta.tag_recargomoroso");
                    fnBuildInfoTags([
                        ["panelfinanzasedocuenta.tag_descript", tagRecargos],
                        ["panelfinanzasedocuenta.d_field_recargo", UIUtilFormat._CurrencyFmt(dato.Recargo)],
                        ["panelfinanzasedocuenta.tag_fechamorosidad", null],
                        ["panelfinanzasedocuenta.tag_recargosmorosidad", null]
                    ]);

                    const recargo = (dato as MFinanzaEdoCtaMovimientoDetalle);
                    const morosidadRes = await _SvFinanzasObtenerCargoAplicadoPorID(recargo.IdCargo);

                    if (morosidadRes.Resultado > 0) {
                        fnBuildInfoTags([
                            ["panelfinanzasedocuenta.tag_descript", tagRecargos],
                            ["panelfinanzasedocuenta.d_field_recargo", UIUtilFormat._CurrencyFmt(dato.Recargo)],
                            ["panelfinanzasedocuenta.tag_fechamorosidad", UIUtilTime._DateFormatStandar(recargo.FechaMorosidad, "d MMM yyyy")],
                            ["panelfinanzasedocuenta.tag_recargosmorosidad", (UIUtilViewFinanzaCargo._GetStrRecargosCol(morosidadRes.Datos) || "N/A")]
                        ]);
                    } else {
                        NotificacionV2._Mostrar(_L("general.notif_infonodisponible"), "ADVERTENCIA");
                    }
                    modalThings.Progress.attr("oculto", true);
                    break;
            }
        }
    })
}